<template>
  <div class="subscription-blocked-modal">
    <div class="modal-icon">
      <i class="material-icons">lock</i>
    </div>
    <h5>Acesso temporariamente suspenso</h5>
    <p>O acesso a este curso está suspenso devido a um pagamento pendente na sua assinatura. Regularize sua assinatura para continuar acessando o conteúdo.</p>
    <button class="btn-manage" :disabled="isLoading" @click="handleManage">
      <span v-if="isLoading">Aguarde...</span>
      <span v-else>Gerenciar assinatura</span>
    </button>
    <button class="btn-close" :disabled="isLoading" @click="onClose">Fechar</button>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionBlockedModal',
  props: {
    onManage: { type: Function, required: true },
    onClose: { type: Function, required: true }
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    async handleManage() {
      this.isLoading = true;
      try {
        await this.onManage();
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.subscription-blocked-modal {
  padding: 32px 28px;
  text-align: center;

  .modal-icon {
    margin-bottom: 12px;

    i {
      font-size: 42px;
      color: #9747ff;
    }
  }

  h5 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0 0 12px;
  }

  p {
    font-size: 14px;
    color: #717171;
    line-height: 1.5;
    margin: 0 0 24px;
  }

  .btn-manage,
  .btn-close {
    display: block;
    width: 100%;
    border-radius: 8px;
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    border: none;

    & + & {
      margin-top: 10px;
    }
  }

  .btn-manage {
    background: #9747ff;
    color: #fff;

    &:hover:not(:disabled) {
      background: darken(#9747ff, 8%);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .btn-close {
    background: transparent;
    color: #9747ff;
    border: 1px solid #9747ff;

    &:hover:not(:disabled) {
      background: rgba(151, 71, 255, 0.06);
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
}
</style>
